import escapeHtml from 'escape-html';

// TODO: remove internal URL logic after its no longer necessary

const PREVIOUS_DOMAIN = 'test.coinpaper';

export const escapeExternalUrl = (url: string) => escapeHtml(url);

export const escapeInternalUrl = (url: string) => {
  const hasPreviousDomain = url.includes(PREVIOUS_DOMAIN);

  if (hasPreviousDomain) {
    const newUrl = url.replace(PREVIOUS_DOMAIN, 'coinpaper');

    return escapeHtml(newUrl);
  }

  return escapeHtml(url);
};
